import DOMPurify from 'dompurify';
import type { ReadingComprehensionBlock, SourceLanguageCode } from '@ellie/shared';
import { BlockHeader } from '../BlockHeader';
import { NativeHint } from '../NativeHint';

interface Props {
  block: ReadingComprehensionBlock;
  index: number;
  nativeLanguage: SourceLanguageCode;
  pageNumber: number;
}

export function ReadingComprehensionPreview({ block, index, nativeLanguage, pageNumber }: Props) {
  return (
    <div className="wb-page">
      <BlockHeader block={block} index={index} />

      {/* Reading passage */}
      <div className="wb-reading-passage">
        {block.textType && <span className="wb-passage-type">{block.textType}</span>}
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(block.text.replace(/\n/g, '<br />')),
          }}
        />
      </div>

      {/* Questions */}
      <div className="wb-reading-questions">
        {block.questions.map((q, i) => (
          <div key={i} className="wb-reading-question">
            <p className="wb-question-text">
              <span className="wb-fill-number">{i + 1}</span>
              {q.question}
            </p>
            <NativeHint text={q.questionNative} nativeLanguage={nativeLanguage} />

            {q.type === 'open' && (
              <div className="wb-write-area" style={{ minHeight: '2.5rem', marginTop: '0.5rem' }} />
            )}

            {q.type === 'multiple_choice' && q.options && (
              <div className="wb-question-options">
                {q.options.map((opt, j) => (
                  <div key={j} className="wb-question-option">
                    <span className="wb-option-letter">{String.fromCharCode(97 + j)}</span>
                    {opt}
                  </div>
                ))}
              </div>
            )}

            {q.type === 'true_false' && (
              <div className="wb-question-options" style={{ flexDirection: 'row', gap: '1rem' }}>
                <div className="wb-question-option" style={{ flex: 1, justifyContent: 'center' }}>
                  <span className="wb-option-letter">V</span> True
                </div>
                <div className="wb-question-option" style={{ flex: 1, justifyContent: 'center' }}>
                  <span className="wb-option-letter">F</span> False
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <span className="wb-page-number">{pageNumber}</span>
    </div>
  );
}
